module.exports = __webpack_public_path__ + "static/img/品牌logo2@3x.58e8e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/品牌logo2@3x.png
// module id = zfzt
// module chunks = 192